import React, { useState } from "react";
import {
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
  Table,
  Row,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import PaginatedItems from "../../components/PaginatedItems";
import ReactSelect from "../../components/ReactSelect";
import TextEditor from "../../components/TextEditor";
import CustomDateRangePicker from "../../components/CustomDateRangePicker";

const DashboardPage = () => {
  const [checked, setChecked] = useState(false);
  const [message, setMessage] = useState(false);

  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  // dropdown
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  // date range
  const [filters, setFilters] = useState({
    dateRange: {
      startDate: null,
      endDate: null,
    },
  });
  const _onDatesChange = (startDate = null, endDate = null) => {
    const newFilters = { ...filters };

    newFilters["dateRange"] = {
      startDate,
      endDate,
    };
    setFilters(newFilters);
  };

  return (
    <>
      <div className="innerHeader">
        {/* page title */}
        <h2>Page Name</h2>

        <div className="right">
          <Button
            onClick={() => console.log("Add Button Clicked")}
            color="primary"
          >
            Add
          </Button>
        </div>
      </div>

      {/* filter */}
      <div className="filterWrapper">
        <div className="filterIcon">
          <i className="fas fa-filter"></i>
        </div>

        <div className="filterForm">
          <div className="formGroup">
            <Label>Added By</Label>
            <Input type="select">
              <option>All</option>
              <option>Kailash</option>
              <option>Anshumant</option>
              <option>Antareep</option>
            </Input>
          </div>

          <div className="formGroup">
            <Label>Status</Label>
            <Input type="select">
              <option>All</option>
              <option>Active</option>
              <option>Inactive</option>
            </Input>
          </div>

          <div className="formGroup multiSelect">
            <Label>Country</Label>
            <ReactSelect />
          </div>

          <div className="formGroup">
            <Label>Transaction Date</Label>
            <CustomDateRangePicker
              startDate={filters.dateRange.startDate}
              endDate={filters.dateRange.endDate}
              startDateId={"startDate_kpi_dashboard"}
              endDateId={`endDate_kpi_dashboard`}
              onDatesChange={(startDate, endDate) =>
                _onDatesChange(startDate, endDate)
              }
            />
          </div>

          {/* search */}
          <div className="formGroup searchbar">
            <Label>Search</Label>
            <InputGroup>
              <Input placeholder="Search..." />
              <InputGroupText>
                <i className="fas fa-search"></i>
              </InputGroupText>
            </InputGroup>
          </div>
        </div>
      </div>

      <div className="bg-white p-2 mt-4" style={{ borderRadius: 8 }}>
        <Table responsive>
          <thead>
            <tr>
              <th className="checkColumn">
                <FormGroup check>
                  <Input id="checkbox2" type="checkbox" />
                </FormGroup>
              </th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Email ID</th>
              <th>Address</th>
              <th>Status</th>
              <th>Expiry</th>

              <th style={{ width: 150, textAlign: "right" }}>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <FormGroup check>
                  <Input
                    id="checkbox2"
                    type="checkbox"
                    defaultChecked={checked}
                    onChange={() => setChecked(!checked)}
                  />
                </FormGroup>
              </td>
              <td>
                <div className="userInfo tableLink">
                  <img
                    src={
                      require("../../assets/img/default-profile.svg").default
                    }
                    alt="user"
                  />
                  Kailash
                </div>
              </td>
              <td>+918375989898</td>
              <td>kailash@logic-square.com</td>
              <td>San Antonio , Texas , United States</td>
              <td>
                <FormGroup switch>
                  <Input type="checkbox" />
                </FormGroup>
              </td>

              <td>27 Feb, 2020</td>
              <td style={{ width: 100, textAlign: "right" }}>
                <div className="action">
                  <Button color="link" className="edit">
                    <i className="fas fa-pencil-alt"></i>
                  </Button>
                  <Button color="link" className="delete">
                    <i className="fas fa-trash-alt"></i>
                  </Button>
                  <Button color="link" className="edit">
                    <i className="far fa-eye"></i>
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <FormGroup check>
                  <Input
                    id="checkbox2"
                    type="checkbox"
                    defaultChecked={checked}
                    onChange={() => setChecked(!checked)}
                  />
                </FormGroup>
              </td>
              <td>
                <div className="userInfo tableLink">
                  <img
                    src={
                      require("../../assets/img/default-profile.svg").default
                    }
                    alt="user"
                  />
                  Kailash
                </div>
              </td>
              <td>+918375989898</td>
              <td>kailash@logic-square.com</td>
              <td>San Antonio , Texas , United States</td>
              <td>
                <FormGroup switch>
                  <Input type="checkbox" />
                </FormGroup>
              </td>

              <td>27 Feb, 2020</td>
              <td style={{ width: 100, textAlign: "right" }}>
                <div className="action">
                  <Button color="link" className="edit">
                    <i className="fas fa-pencil-alt"></i>
                  </Button>
                  <Button color="link" className="delete">
                    <i className="fas fa-trash-alt"></i>
                  </Button>
                  <Button color="link" className="edit">
                    <i className="far fa-eye"></i>
                  </Button>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      {/* pagination */}
      <PaginatedItems itemsPerPage={4} />

      {/* message */}
      {checked === true ? (
        <div className="main_content_wrapper mt-3">
          <Row>
            <Col md="12">
              <FormGroup check inline>
                <Input
                  type="radio"
                  id="emailMessage"
                  value="Email Message"
                  name="option"
                  onChange={handleMessage}
                />
                <Label check for="emailMessage">
                  Email Message
                </Label>
              </FormGroup>
              <FormGroup check inline>
                <Input
                  type="radio"
                  id="textMessage"
                  value="Text Message"
                  name="option"
                  onChange={handleMessage}
                />
                <Label check for="textMessage">
                  Text Message
                </Label>
              </FormGroup>
            </Col>

            <Col lg={8} xl={6}>
              {message === "Email Message" ? (
                <FormGroup>
                  <div className="messageVeriabel">
                    <Label>Subject </Label>
                    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                      <DropdownToggle caret>Insert Variables</DropdownToggle>
                      <DropdownMenu end>
                        <DropdownItem>Some Action</DropdownItem>
                        <DropdownItem>Some Action</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <Input />
                </FormGroup>
              ) : null}
              <FormGroup>
                <div className="messageVeriabel">
                  <Label>Body </Label>
                  <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>Insert Variables</DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem>Some Action</DropdownItem>
                      <DropdownItem>Some Action</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
                <TextEditor />
              </FormGroup>

              <Button color="primary">Send</Button>
            </Col>
          </Row>
        </div>
      ) : null}
    </>
  );
};

export default DashboardPage;
